module.exports = __webpack_public_path__ + "78f259905f8cb5a93ecb91aeb39d48c7.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-overpass-mono/files/overpass-mono-latin-300.woff
// module id = 167
// module chunks = 1